import React, { Fragment } from "react";
import { fetchDeal } from "store/state/deal";
import { getNotificationsByDeal } from "store/state/notifications";
import { connect } from "react-redux";
import styled from "styled-components";
import {Grid, Button} from "@material-ui/core";
import dealById from "selectors/deal";
import { getDealMetrics } from "store/state/deal";
import { getGuestsByDealId} from 'store/state/guest'
import Header from "./Header";
import { ACCESS_TYPE_PORTFOLIO_DEAL } from "constants/accessTypes";
import MetricTile from "components/Global/Metric/MetricTile";
import { getScreenPreferences } from "../../shared-utility/store/state/screenPreferences";
import DealViewAndEdit from 'components/Deal/DealViewAndEdit';
import LoanView from './DealDetailsSections/LoanView';
import HedgeView from './DealDetailsSections/HedgeView';
import GuestView from '../GuestView';
import { DEAD, SOLD } from "constants/status";
import guestPermissionHelper from "utils/guestPermissionHelper"

const screenType = "deal_view_metric";
const PaddedContainer = styled.div`
  padding: 5px 16px;
`;
const PaddedMetricDiv = styled.div`
  padding: 32px 16px;
`;
const ContainerDiv = styled.div`
  overflow-y: hidden;
`;
const StyledActionButton = styled(Button)`
    && {
        margin-left: 4px;
        padding: 8px 8px 8px 2px;
        border-radius: 0;
        color: #2196f3;
        background: none;
    }
    &&:hover {
        background: none;
    }
`;

class DealDetails extends React.Component {
  state = {
    addEditAlertIsOpen: false,   
    isAlert: true,    
    confirmDialogOpen: false,
    guestPermissions: {isGuest: false}

  }
  shouldIncludeAlertButtons(){
    const {deal} = this.props;
    return deal && deal.dealStatusId !== DEAD && deal.dealStatusId !== SOLD;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location && nextProps.location && this.props.location.pathname !== nextProps.location.pathname) {
      window.location.reload();
    }
  }
  
  componentDidMount() {
    const { dealId } = this.props.match.params;
    this.props.getGuestsByDealId({ dealId: dealId, accessTypeId: ACCESS_TYPE_PORTFOLIO_DEAL  })
    this.props.getDealMetrics({ dealId: dealId });
    this.findScreenPreferences();
    this.props.fetchDeal(dealId);    
  }

  findScreenPreferences = () =>{
    const { dealId } = this.props.match.params;
    this.props.getScreenPreferences({
      screenType,
      isGuest: this.props.authentication.isGuest,
      dealId: dealId
    });  
  }

  componentDidUpdate(){
    const shouldBuildGuestPermissions = guestPermissionHelper.shouldBuildGuestPermissions(this.props.authentication.guestAccess,
                                                                                          this.props.deal,
                                                                                          this.props.guestPermission,
                                                                                          this.props.dealguests);

    if(shouldBuildGuestPermissions && !this.state.guestPermissions.isGuest){
      const guestPermissions = guestPermissionHelper.buildGuestPermissions(this.props.authentication.guestAccess,
                                                                            this.props.deal,
                                                                            this.props.guestPermission,
                                                                            this.props.dealguests,
                                                                            "portfolioPermission",
                                                                                          this.props.history);
      this.setState({guestPermissions: guestPermissions});
    }
  }

  refreshDeal = () => {
    const { dealId } = this.props.match.params;
    this.props.fetchDeal(dealId); 
  }

  addAlert = () => { 
    this.props.getNotificationsByDeal({dealId : this.props.deal.id}); 
    this.setState({addEditAlertIsOpen: true, isAlert: true});};
  setReminder = () => {this.props.getNotificationsByDeal({dealId : this.props.deal.id}); this.setState({addEditAlertIsOpen: true, isAlert: false});};
  handleCancelAlertReminder = () => {this.setState({addEditAlertIsOpen: false,confirmDialogOpen: false});};  
  handleSaveAlertReminder = () => {this.setState({ addEditAlertIsOpen: false,confirmDialogOpen: false});};

  render() {
    // const { currentTab, sidebyside, message } = this.state;
    const {
      deal,
      screen_pref,
      metricData,
      dealId,
    } = this.props;

    if (!deal) return null;
    
    if(deal.isAuthorized !== undefined && !deal.isAuthorized) {
      this.props.history.push("/AccessDenied");
      return null;
    }

    return (
      <Fragment>
        <ContainerDiv>
        <PaddedContainer>
          {/* <AssignFund /> */}
          <Grid
            container
            spacing={8}
            alignItems="flex-start"
            justify="flex-start"
            direction="row"
          >
            <Grid item sm={12}>
              <Header 
                deal={deal}
                includeAlertButtons={this.shouldIncludeAlertButtons()}
                //Alert / Reminder Props
                addEditAlertIsOpen={this.state.addEditAlertIsOpen}
                isAlert={this.state.isAlert}
                addAlert={this.addAlert}
                setReminder={this.setReminder}
                handleCancel={this.handleCancelAlertReminder}
                handleSave={this.handleSaveAlertReminder}
                guestPermissions={this.state.guestPermissions}
                />
              <PaddedMetricDiv>
                <MetricTile
                  screenType={screenType}
                  tileData={screen_pref}
                  metricData={metricData}
                  guestPermissions={this.state.guestPermissions}
                  updateContactScreenPreferencesCallback={this.findScreenPreferences}
                />
              </PaddedMetricDiv>
            </Grid>
          </Grid>
          <Grid item sm={12}>
            <DealViewAndEdit
              deal={deal} 
              refreshDeal={this.refreshDeal}
              guestPermissions={this.state.guestPermissions}/>
          </Grid>
          <Grid item sm={12}>
            <LoanView dealId={deal.id}
              guestPermissions={this.state.guestPermissions} />
          </Grid>          
          <Grid item sm={12}>
            <HedgeView dealId={deal.id}
              guestPermissions={this.state.guestPermissions} />
          </Grid>
          {!this.props.authentication.isGuest && 
            <Grid item sm={12}>
              <GuestView dealId={deal.id} isPortfolio accessTypeId={ACCESS_TYPE_PORTFOLIO_DEAL}
                guestPermissions={this.state.guestPermissions}/>
            </Grid>}
        </PaddedContainer>
        </ContainerDiv>
      </Fragment>
    );
  }
}

const mapStateToProps = (  
  state,
  {
    match: {
      params: { dealId }
    }
  }
) => {
  const {
    authentication,
    loading,
    screenPreferences,
    deal,
    guest
  } = state;
  return {
    authentication,
    loading,
    deal: dealById(state, dealId),
    screen_pref: screenPreferences.screen_pref.deal_view_metric || null,
    metricData: deal.metricData,
    dealguests: guest.dealguests ? guest.dealguests[dealId] : [],
    guestPermission: guest.guestPermission ? guest.guestPermission : null,
  };
};

export default connect(
  mapStateToProps,
  {
    fetchDeal,
    getNotificationsByDeal,
    getScreenPreferences,
    getDealMetrics,
    getGuestsByDealId
  })(DealDetails);
